module.exports = __webpack_public_path__ + "static/media/matching-education-medial-nonflexion-up.3b604dbe.png";